import { DESIRED_COUNT_DEFAULT, NUMBER_OF_VALUE_DEFAULT, } from './automatic-facet-set-constants.js';
export function getAutomaticFacetSetInitialState() {
    return {
        desiredCount: DESIRED_COUNT_DEFAULT,
        numberOfValues: NUMBER_OF_VALUE_DEFAULT,
        set: {},
    };
}
